import React, { Component } from 'react'
import { Exhibition } from 'hlj-components'
import style from './style.module.less'
import { observer } from 'mobx-react'
import columns from './columns'

@observer
export default class extends Component {
  render() {
    return (
      <div className={style.item}>
        <div className={style.header}>账单{this.props.index + 1}</div>

        <div className={style.content}>
          <Exhibition columns={columns} data={this.props.item} />
        </div>
      </div>
    )
  }
}
